import { apiPaths } from "@/lib/api/paths";
import type { ExternalTaxonomyResponse } from "./types";
import axios from "axios";

// Encodes the species name and fetches data from the external GBIF API.
// Used to populate the TaxonomicGroups model with full species information.
export async function searchSpeciesByName(
  speciesName: string,
): Promise<ExternalTaxonomyResponse> {
  const url = `${apiPaths.gbif.speciesMatch}${encodeURIComponent(speciesName)}`;
  const response = await axios.get<ExternalTaxonomyResponse>(url);
  return response.data;
}
